import React from "react";

function Podscribe(
  props: React.SVGProps<SVGSVGElement>,
  ref: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      version="1.1"
      id="svg1"
      xmlns="http://www.w3.org/2000/svg"
      {...{ ...props, ref }}
    >
      <defs id="defs1">
        <clipPath clipPathUnits="userSpaceOnUse" id="clipPath282">
          <path d="M 0,0 H 1920 V 1080 H 0 Z" id="path282" />
        </clipPath>
      </defs>
      <g id="layer1">
        <rect
          fill="#19283b"
          fillOpacity={1}
          strokeWidth={1.89012}
          id="rect1"
          width="24"
          height="24"
          x="0"
          y="0"
        />
        <path
          id="path281"
          d="m 49.58367,1054 c 2.49542,0 4.51836,-2.008 4.51836,-4.486 v -17.445 c 0,-0.826 0.67432,-1.496 1.50613,-1.496 0.8318,0 1.50612,0.67 1.50612,1.496 v 4.984 c 0,3.028 2.47248,5.483 5.52245,5.483 0.8318,0 1.50612,-0.67 1.50612,-1.495 0,-0.826 -0.67432,-1.496 -1.50612,-1.496 -1.38635,0 -2.51021,-1.115 -2.51021,-2.492 v -4.984 c 0,-2.478 -2.02294,-4.486 -4.51836,-4.486 -2.49543,0 -4.51837,2.008 -4.51837,4.486 v 17.445 c 0,0.826 -0.67431,1.495 -1.50612,1.495 -0.83181,0 -1.50612,-0.669 -1.50612,-1.495 v -22.928 c 0,-2.478 -2.02295,-4.486 -4.51837,-4.486 -2.49542,0 -4.51837,2.008 -4.51837,4.486 v 17.445 c 0,0.826 -0.67431,1.496 -1.50612,1.496 -0.83181,0 -1.50612,-0.67 -1.50612,-1.496 v -4.984 c 0,-3.028 -2.47248,-5.483 -5.52245,-5.483 -0.83181,0 -1.50612,0.67 -1.50612,1.495 0,0.826 0.67431,1.496 1.50612,1.496 1.38635,0 2.51021,1.115 2.51021,2.492 v 4.984 c 0,2.478 2.02294,4.486 4.51836,4.486 2.49543,0 4.51837,-2.008 4.51837,-4.486 v -17.445 c 0,-0.826 0.67431,-1.495 1.50612,-1.495 0.83181,0 1.50612,0.669 1.50612,1.495 v 22.928 c 0,2.478 2.02294,4.486 4.51837,4.486 z"
          fill="#ffffff"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          transform="matrix(0.61397875,0,0,-0.61397875,-16.593865,649.34064)"
          clipPath="url(#clipPath282)"
        />
      </g>
    </svg>
  );
}

export default React.forwardRef(Podscribe);
